// NEW_FILE_JUSTIFIED: Form state hook for provider create/edit — no existing hook covers provider + contacts array
// HOOK_STATE_JUSTIFIED: form state management hook — extracted per max-2-useState rule
import { useState, useCallback } from 'react';
import type { IProviderContact, IInsuranceProvider } from '@/@types/insurance';

const EMPTY_CONTACT: IProviderContact = {
  name: '',
  phone: '',
  email: undefined,
  whatsapp: undefined,
  telegram: undefined,
  viber: undefined,
};

export function useProviderForm() {
  const [name, setName] = useState('');
  const [country, setCountry] = useState('');
  const [website, setWebsite] = useState('');
  const [contacts, setContacts] = useState<IProviderContact[]>([]);

  const addContact = useCallback(() => {
    setContacts(prev => {
      if (prev.length >= 5) return prev;
      return [...prev, { ...EMPTY_CONTACT }];
    });
  }, []);

  const removeContact = useCallback((index: number) => {
    setContacts(prev => prev.filter((_, i) => i !== index));
  }, []);

  const updateContact = useCallback(
    (index: number, field: keyof IProviderContact, value: string) => {
      setContacts(prev => {
        const next = [...prev];
        next[index] = { ...next[index], [field]: value || undefined };
        return next;
      });
    },
    []
  );

  const initFromExisting = useCallback((provider: IInsuranceProvider) => {
    setName(provider.name);
    setCountry(provider.country ?? '');
    setWebsite(provider.website ?? '');
    setContacts(provider.contacts);
  }, []);

  const reset = useCallback(() => {
    setName('');
    setCountry('');
    setWebsite('');
    setContacts([]);
  }, []);

  return {
    name,
    setName,
    country,
    setCountry,
    website,
    setWebsite,
    contacts,
    addContact,
    removeContact,
    updateContact,
    initFromExisting,
    reset,
  };
}
